var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVisibilityOff = function SvgVisibilityOff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.037 2.947c2.045 0 3.652 1.621 3.652 3.685 0 .442-.073.957-.292 1.326l2.119 2.137c1.096-.958 1.973-2.137 2.484-3.463a8.61 8.61 0 0 0-8.037-5.527c-1.022 0-1.972.221-2.922.516l1.607 1.621c.439-.22.95-.295 1.389-.295zM.73.957l1.68 1.696.292.294C1.461 3.905.511 5.157 0 6.632a8.61 8.61 0 0 0 8.037 5.526c1.095 0 2.191-.221 3.214-.59l.292.295L13.663 14l.949-.958L1.68 0 .73.958zm4.018 4.054 1.096 1.105v.516c0 1.252.95 2.21 2.192 2.21.146 0 .292 0 .51-.074l1.097 1.106a3.108 3.108 0 0 1-1.607.442c-2.046 0-3.653-1.621-3.653-3.684 0-.59.146-1.106.365-1.621zm3.141-.59 2.265 2.284v-.147c0-1.253-.95-2.21-2.192-2.21 0 .073 0 .073-.073.073z",
    fill: "#CCC",
    fillRule: "evenodd"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVisibilityOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/visibility-off.c97bbb5e.svg";
export { ForwardRef as ReactComponent };